import React from 'react';
import teamGoalsCta from 'images/teamGoalsCta.jpg';
import { TRACKING } from 'common/constants/constants';
import CtaPage from 'components/CtaPage';
import { TEXT_POSITION } from 'components/CtaPage/constants';
import { DUMMY_SECTIONS_TEAM_GOALS } from './constants';
import AppRouter from 'common/AppRouter';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const SECTION_TYPES = {
  LARGE_PULL_REQUESTES: 'LARGE_PULL_REQUESTES',
  REVIEW_REQUEST_HANGING: 'REVIEW_REQUEST_HANGING',
  MERGED_WITHOUT_REVIEW: 'MERGED_WITHOUT_REVIEW'
};

const TEXTS = {
  [SECTION_TYPES.LARGE_PULL_REQUESTES]:
    ' Large pull requests can complicate the review process and extend development cycles.' +
    ' Utilize LinearB to segment these into more manageable units,' +
    ' thereby streamlining code integration. Learn more about managing large pull requests with LinearB.',
  [SECTION_TYPES.REVIEW_REQUEST_HANGING]:
    'Elite engineering teams have an average pickup time under 24 hours, which is a key factor in' +
    ' limiting cycle time. Use LinearB to establish clear goals backed by automatic notifications' +
    ' and alerts when things are at risk of falling behind.',
  [SECTION_TYPES.MERGED_WITHOUT_REVIEW]:
    'Give engineering management the visibility they need to spot inefficiencies and quality risks' +
    ' in the software delivery process. Drill down to the most granular level to analyze every gap' +
    " in your organization's process."
};

const TeamGoalsCTA = ({ showClose = true }) => {
  const history = useHistory();

  const onCloseClick = () => {
    history.push(AppRouter.PERFORMANCE.path);
  };

  return (
    <CtaPage
      {...(showClose && {
        onCloseClick
      })}
      textsMap={TEXTS}
      page={TRACKING.PAGES.METRICS}
      pageTab={TRACKING.PAGE_TABS.TEAM_GOALS_CTA}
      buttonLineProps={{
        textWidth: '60%',
        leftText: 'STANDARDIZE GOALS AND REPORTING',
        buttonText: 'SCHEDULE A CONSULTATION'
      }}
      backgroundImage={teamGoalsCta}
      sections={[
        {
          sectionType: SECTION_TYPES.LARGE_PULL_REQUESTES,
          buttonPosition: {
            left: '30%',
            top: '8.5rem'
          },
          coverProps: {
            height: '20rem',
            width: '24rem',
            position: { top: '4rem', left: '14rem' }
          },
          textPosition: { left: TEXT_POSITION, top: '12rem' },
          isTextLeft: true,
          arrowLength: '13rem'
        },
        {
          sectionType: SECTION_TYPES.REVIEW_REQUEST_HANGING,
          buttonPosition: {
            bottom: '18rem',
            left: '47rem'
          },
          coverProps: {
            height: '20rem',
            width: '28%',
            position: { bottom: '5.45rem', left: '36rem' }
          },
          textPosition: { right: TEXT_POSITION, bottom: '-5rem' },
          arrowLength: '24rem'
        },
        {
          sectionType: SECTION_TYPES.MERGED_WITHOUT_REVIEW,
          buttonPosition: {
            bottom: '17.9rem',
            right: '11.5rem'
          },
          coverProps: {
            height: '20rem',
            width: '29%',
            position: {
              bottom: '5.45rem',
              right: 0
            }
          },
          textPosition: { right: TEXT_POSITION, top: '28rem' }
        }
      ].concat(DUMMY_SECTIONS_TEAM_GOALS)}
    />
  );
};

export default TeamGoalsCTA;
